<template>
  <div class="list-wrapper">
    <h1>Oops!</h1>
    <h3>The {{ resource }} already exists.</h3>

    <p>Try again? <a href="#" @click="$router.go(-1)"> Go back </a> to try</p>

    <router-link :to="{ name: 'Home' }">Back to the home page</router-link>
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true,
      default: "page",
    },
  },
};
</script>
